// actions/fileActions.js
import axios from '../../utils/axiosConfig';
// import axios from 'axios';
import {
  FETCH_FILES_REQUEST,
  FETCH_FILES_SUCCESS,
  FETCH_FILES_FAIL,
  FILE_DETAILS_REQUEST,
  FILE_DETAILS_SUCCESS,
  FILE_DETAILS_FAIL,
  CREATE_FILE_SUCCESS,
  CREATE_FILE_FAIL,
  UPDATE_FILE_SUCCESS,
  UPDATE_FILE_FAIL,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAIL,
  CREATE_FILE_REQUEST,
} from '../constants/fileConstants';

// Fetch all files
export const fetchFiles = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_FILES_REQUEST });
    const { data } = await axios.get('/api/files');
    // console.log("Fetch files ", data);
    dispatch({ type: FETCH_FILES_SUCCESS, payload: data });
  } catch (error) {
    // console.log("Fetch files error ", error);
    dispatch({
      type: FETCH_FILES_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Get details of a specific file
export const getFile = (id) => async (dispatch) => {
  try {
    dispatch({ type: FILE_DETAILS_REQUEST });
    const { data } = await axios.get(`/api/files/${id}`);
    dispatch({ type: FILE_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FILE_DETAILS_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Create a new file
export const createFile = (fileData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_FILE_REQUEST });
    const { data } = await axios.post('/api/files', fileData);
    dispatch({ type: CREATE_FILE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CREATE_FILE_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Update an existing file
export const updateFile = (id, updatedFileData) => async (dispatch) => {
  try {
    const { data } = await axios.put(`/api/files/${id}`, updatedFileData);
    dispatch({ type: UPDATE_FILE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: UPDATE_FILE_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

// Delete a file
export const deleteFile = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/files/${id}`);
    dispatch({ type: DELETE_FILE_SUCCESS, payload: id });
  } catch (error) {
    dispatch({
      type: DELETE_FILE_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};
